import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { VerificationType } from '@/modules/user/components/Verification/verification.types';

interface Body {
  value: string;
  type: VerificationType;
}

const useSendVerificationCodeQuery = () => {
  const {
    mutateAsync,
    isLoading = false,
    isError,
  } = useMutation((body: Body) =>
    api.post(API_URL.CODES_VERIFICATIONS, {
      value: body.value,
      type: body.type,
    })
  );

  return {
    sendVerificationCode: mutateAsync,
    isLoading,
    isError,
  };
};

export default useSendVerificationCodeQuery;
